import React, { useEffect } from "react";
import { useStateIfMounted } from "use-state-if-mounted";
import mqtt_topics from "../../../mqtt/mqtt_topics";
import "./../../../css/app.css";

const Server = (props) => {
  const mac = mqtt_topics.choosenmac;
  const [state, setState] = useStateIfMounted({
    value: "",
    unit: props.unit,
    title: props.title,
    step: props.step,
    disabled: false, //if returned value == na set to false
    progress: false,
    acc: props.acc,
  });
  const [lastReceivedValue, setLastReceivedValue] = useStateIfMounted();
  const target_live_reading_topic =
    mqtt_topics.fixed_topic_part +
    mac +
    "/" +
    props.category +
    "/" +
    props.subcategory +
    "/" +
    props.title;

  function listenforlivedata() {
    props.mqttClient.subscribe(target_live_reading_topic);
    props.mqttClient.on("message", handleMqttMessage);
  }

  function handleMqttMessage(topic, message) {
    if (topic == target_live_reading_topic) {
      try {
        // message is Buffer
        message = JSON.parse(message.toString());
        if (message.value.toLowerCase().toString() == "nv") {
          setState({
            ...state,
            disabled: true,
            progress: false,
          });
        } else {
          setState({
            ...state,
            value: message.value == undefined ? 0 : message.value,
            disabled: false,
            progress: false,
          });
          setLastReceivedValue(message.value == undefined ? 0 : message.value);
        }
      } catch (error) {
        //console.log(message);
      }
    }
  }

  useEffect(() => {
    listenforlivedata();
  }, []);

  //when componenet unmount
  useEffect(
    () => () => {
      props.mqttClient.unsubscribe(target_live_reading_topic);
      props.mqttClient.removeListener("message", handleMqttMessage);
    },
    []
  );

  function setparameter(val) {
    if (!mqtt_topics.busy_Requesting_Data) {
      requestdata(val);
    } else {
      setTimeout(function () {
        requestdata(val);
      }, mqtt_topics.timeouttotrytorequestmqttdata); //wait 1 seconds
    }
  }

  function requestdata(val) {
    mqtt_topics.busy_Requesting_Data = true;
    props.mqttClient.publish(
      mqtt_topics.fixed_topic_part + mac + mqtt_topics.request_topic,
      JSON.stringify({
        param: props.category + "/" + props.subcategory + "/" + props.title,
        value: val.toString(),
      })
    );
    mqtt_topics.busy_Requesting_Data = false;
  }

  function validateIPorDomain(input) {
    const regex = new RegExp(
      "^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$|^([a-zA-Z0-9]([a-zA-Z0-9\\-]{0,61}[a-zA-Z0-9])?\\.)+[a-zA-Z]{2,6}$"
    );
    if (regex.test(input)) {
      setparameter(input);
      setState({
        ...state,
        progress: true,
      });
      alert("none");
    } else {
      alert("block");
    }
  }

  function alert(action) {
    document.getElementById(
      props.category + "/" + props.subcategory + "/" + props.title + "_alert"
    ).style.display = action;
  }

  return (
    <div
      className="grid-item"
      style={{ display: state.disabled ? "none" : "block" }}
    >
      <div style={{ display: state.progress ? "none" : "block" }}>
        {state.title}
        &nbsp;
        <input
          type="text"
          value={state.value == "NV" ? "" : state.value}
          onChange={(e) => {
            alert("none");
            setState({
              ...state,
              value: e.target.value,
            });
          }}
          maxLength="253"
          onBlur={(e) => {
            if (e.target.value != lastReceivedValue) {
              validateIPorDomain(e.target.value);
            }
          }}
          onKeyPress={(e) => {
            if (e.key === "Enter") {
              if (e.target.value != lastReceivedValue) {
                validateIPorDomain(e.target.value);
              }
            }
          }}
          className="serverparamtersinput"
          disabled={!state.acc}
        />
      </div>
      <div
        className="alert alert-danger"
        style={{ display: "none" }}
        id={
          props.category +
          "/" +
          props.subcategory +
          "/" +
          props.title +
          "_alert"
        }
      >
        Not a valid IP address or domain.
      </div>
      <div
        className="spinner-border text-primary"
        style={{ display: state.progress ? "block" : "none" }}
      ></div>
    </div>
  );
};
export default Server;
